import _ from 'lodash';
import { normalize } from 'normalizr';
import React from 'react';
import * as types from '../constants/action-types';
import Projects from '../../../../api/api-projects';
import Listings from '../../../../api/api-listings';
import { Helpers } from 'shared-components/helpers/helpers';
import { projectSchemas } from '../schemas/projects';
import { FormattedMessage } from 'react-intl';

function fetchAttachmentDetails (response) {
  return {
    type: types.ATTACHMENT_DETAIL_SUCCESS,
    response
  };
}

function projectAttachmentCreateRequest (id) {
  return {
    type: types.PROJECT_ATTACHMENTS_CREATE_REQUEST,
    id
  };
}

export function projectAttachmentsCreateSuccess (response) {
  return {
    type: types.PROJECT_ATTACHMENTS_CREATE_SUCCESS,
    response
  };
}

export function projectAttachmentsCreateFailure (id, error) {
  return {
    type: types.PROJECT_ATTACHMENTS_CREATE_FAILURE,
    id,
    error
  };
}

function projectAttachmentDeleteRequest (id) {
  return {
    type: types.PROJECT_ATTACHMENTS_DELETE_REQUEST,
    id
  };
}

export function projectAttachmentsDeleteSuccess (response) {
  return {
    type: types.PROJECT_ATTACHMENTS_DELETE_SUCCESS,
    response
  };
}

export function projectAttachmentsDeleteFailure (id, error) {
  return {
    type: types.PROJECT_ATTACHMENTS_DELETE_FAILURE,
    id,
    error
  };
}

function projectAttachmentFetchRequest (id) {
  return {
    type: types.PROJECT_ATTACHMENTS_FETCH_REQUEST,
    id
  };
}

export function projectAttachmentsFetchSuccess (response) {
  return {
    type: types.PROJECT_ATTACHMENTS_FETCH_SUCCESS,
    response
  };
}

export function projectAttachmentsFetchFailure (id, error) {
  return {
    type: types.PROJECT_ATTACHMENTS_FETCH_FAILURE,
    id,
    error
  };
}

export function projectFetchSuccess (response) {
  return {
    type: types.PROJECT_FETCH_SUCCESS,
    schema: projectSchemas.PROJECT,
    response
  };
}

function projectFetchRequest (id) {
  return {
    type: types.PROJECT_FETCH_REQUEST,
    id
  };
}

function projectFetchFailure (id, error) {
  return {
    type: types.PROJECT_FETCH_FAILURE,
    id,
    error
  };
}

function projectUpdateSuccess (response) {
  return {
    type: types.PROJECT_UPDATE_SUCCESS,
    schema: projectSchemas.PROJECT,
    response
  };
}

function projectUpdateRequest (id) {
  return {
    type: types.PROJECT_UPDATE_REQUEST,
    id
  };
}

function projectUpdateFailure (id, error) {
  return {
    type: types.PROJECT_UPDATE_FAILURE,
    id,
    error
  };
}

function projectAttachmentsBatchUpdateRequest () {
  return {
    type: types.PROJECT_ATTACHMENTS_UPDATE_REQUEST
  };
}

function projectAttachmentsBatchUpdateSuccess (response, rawResponse) {
  return {
    type: types.PROJECT_ATTACHMENTS_UPDATE_SUCCESS,
    schema: projectSchemas.ATTACHMENTS_ARRAY,
    response,
    rawResponse
  };
}

function projectAttachmentsBatchUpdateFailure (id, error) {
  return {
    type: types.PROJECT_ATTACHMENTS_UPDATE_FAILURE,
    error
  };
}

function boardDeleteRequest (boardID) {
  return {
    type: types.PROJECT_BOARD_DELETE_REQUEST,
    boardID
  };
}

function boardDeleteSuccess (boardExternalID) {
  return {
    type: types.PROJECT_BOARD_DELETE_SUCCESS,
    externalID: boardExternalID
  };
}

function boardDeleteFailure (id, error) {
  return {
    type: types.PROJECT_BOARD_DELETE_FAILURE,
    id,
    error
  };
}

// board COPY store updates
function boardCopyRequest (boardID) {
  return {
    type: types.PROJECT_BOARD_COPY_REQUEST,
    boardID
  };
}

function boardCopySuccess (response) {
  return {
    type: types.PROJECT_BOARD_COPY_SUCCESS,
    response
  };
}

function boardCopyFailure (boardCopyError) {
  return {
    type: types.PROJECT_BOARD_COPY_FAILURE,
    response: {
      entities: {
        boardCopyError
      }
    }
  };
}

function boardCopySuccessClearState () {
  return {
    type: types.CLEAR_PROJECT_BOARD_COPY_SUCCESS,
    response: {
      entities: {
        boardCopyExternalID: ''
      }
    }
  };
}


function boardCopyFailureClearState () {
  return {
    type: types.CLEAR_PROJECT_BOARD_COPY_FAILURE,
    response: {
      entities: {
        boardCopyError: null
      }
    }
  };
}

const createProjectAttachments = (projectID, attachmentID, accessToken, ns, projectInviteId, voteId) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch(projectAttachmentCreateRequest(projectID));
      return Projects.createAttachmentsByProjectID(projectID, attachmentID, accessToken, ns, projectInviteId, null, (res) => {
        if (res.error || 200 !== res.statusCode) {
          dispatch(projectAttachmentsCreateFailure(projectID, res.error));
          return reject(res.message);
        }
        if ('COLLABORATOR' === ns) {
          return resolve(res);
        }
        const { entities: { attachments: attachmentsByListing = {} } } = getState();
        const reducedAttachments = _.reduce(attachmentsByListing, (acc, val) => {
          const attachVal = val || {};
          const { attachment: { value = '' } } = res;
          // compare id of attachment from existing attachment state
          // with response value (fav_board_attachment_id)
          if (attachVal._id === value) {
            const downvotes = attachVal.downvotes || 0;
            const upvotes = attachVal.upvotes || 0;
            if ('DOWNVOTE' === ns) {
              attachVal.downvotes = downvotes + 1;
              if (voteId) {
                attachVal.upvotes = 0 < upvotes ? upvotes - 1 : upvotes;
              }
            } else if ('UPVOTE' === ns) {
              attachVal.upvotes = upvotes + 1;
              if (voteId) {
                attachVal.downvotes = 0 < downvotes ? downvotes - 1 : downvotes;
              }
            }
            const reqAttachments = attachVal.requester_attachments;
            const newReqAttachments = Helpers.removeByKey(reqAttachments, voteId);
            const responseAttachment = _.get(res, ['attachment'], {});
            newReqAttachments[responseAttachment._id] = responseAttachment;
            attachVal.requester_attachments = newReqAttachments;
          }
          acc.push(attachVal);
          return acc;
        }, []);
        const normalizedAttachments = { ...normalize(reducedAttachments, projectSchemas.ATTACHMENTS_ARRAY) };
        return resolve(dispatch({
          type: types.PROJECT_ATTACHMENTS_CREATE_SUCCESS,
          schema: projectSchemas.ATTACHMENTS_ARRAY,
          response: normalizedAttachments
        }));
      });
    });
  };
};

export const createAttachments = (projectID, attachmentID, accessToken, ns, projectInviteId, voteId) => (dispatch) => {
  return dispatch(createProjectAttachments(projectID, attachmentID, accessToken, ns, projectInviteId, voteId));
};

const deleteProjectAttachments = (listingID, attachmentID, accessToken, ns) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch(projectAttachmentDeleteRequest(attachmentID));
      return Projects.deleteAttachmentsByProjectID(attachmentID, accessToken, (res) => {
        if (res.error || 200 !== res.statusCode) {
          dispatch(projectAttachmentsDeleteFailure(attachmentID, res.error));
          return reject(res.message);
        }
        const { entities: { attachments: attachmentsByListing = {} } } = getState();
        const reducedAttachments = _.reduce(attachmentsByListing, (acc, val, key) => {
          const attachVal = val;
          // compare id of attachment from existing attachment state
          // with response value (fav_board_attachment_id)
          if (key === listingID) {
            const downvotes = attachVal.downvotes || 0;
            const upvotes = attachVal.upvotes || 0;
            if ('DOWNVOTE' === ns) {
              attachVal.downvotes = 0 >= downvotes ? 0 : downvotes - 1;
            } else if ('UPVOTE' === ns) {
              attachVal.upvotes = 0 >= upvotes ? 0 : upvotes - 1;
            }
            const newReqAttachments = Helpers.removeByKey(attachVal.requester_attachments, res._id);
            attachVal.requester_attachments = newReqAttachments;
          }
          acc.push(attachVal);
          return acc;
        }, []);
        const normalizedAttachments = { ...normalize(reducedAttachments, projectSchemas.ATTACHMENTS_ARRAY) };
        return resolve(dispatch({
          type: types.PROJECT_ATTACHMENTS_DELETE_SUCCESS,
          schema: projectSchemas.ATTACHMENTS_ARRAY,
          response: normalizedAttachments
        }));
      });
    });
  };
};

export const deleteAttachment = (projectID, attachmentID, accessToken, ns) => (dispatch) => {
  return dispatch(deleteProjectAttachments(projectID, attachmentID, accessToken, ns));
};

const fetchProjectAttachments = (projectID, accessToken) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(projectAttachmentFetchRequest(projectID));
      return Projects.fetchAttachmentsByProjectID(projectID, accessToken, (res) => {
        if (res.error) {
          return reject(dispatch(projectAttachmentsFetchFailure(projectID, res.error)));
        }
        // return resolve(dispatch(projectAttachmentsFetchSuccess(res)));
        const { requester_attachments: requesterAttachments = {}, listing_attachments = [] } = res;
        const requesters = _.reduce(requesterAttachments, (acc, val) => acc.concat(val), []);
        const reducedAttachments = _.reduce(listing_attachments, (acc, val) => {
          const attachVal = val;
          const { _id: attachId } = attachVal;
          const filteredVotes = requesters.filter(request => request.value === attachId);
          attachVal.requester_attachments = _.keyBy(filteredVotes, '_id');
          acc.push(attachVal);
          return acc;
        }, []);
        const normalizedAttachments = { ...normalize(reducedAttachments, projectSchemas.ATTACHMENTS_ARRAY) };
        return resolve(dispatch({
          type: types.PROJECT_ATTACHMENTS_FETCH_SUCCESS,
          schema: projectSchemas.ATTACHMENTS_ARRAY,
          response: normalizedAttachments
        }));
      });
    });
  };
};

export const copyBoard = (projectID, accessToken) => {
  return (dispatch) => {
    dispatch(boardCopyRequest(projectID));
    Projects.copyBoard(projectID, accessToken, (res) => {
      if (res.error) {
        const errorMessage = 403 === res.statusCode ? <FormattedMessage id='boards.projects.already_copied' defaultMessage='You have already copied this board'/> : <FormattedMessage id='boards.projects.error_msg' defaultMessage='An error has occurred, please try again.'/>;
        const copiedBoardExternalID = res.project.external_id || null;
        const boardCopyError = {
          errorMessage,
          boardCopyExternalID: copiedBoardExternalID
        };
        return dispatch(boardCopyFailure(boardCopyError));
      }
      const response = {
        entities: {
          boardCopyExternalID: res.project.external_id
        } };
      dispatch(boardCopySuccess(response));
    });
  };
};

export const clearCopyBoardErrorState = () => {
  return (dispatch) => {
    dispatch(boardCopyFailureClearState());
  };
};


export const clearCopyBoardSuccessState = () => {
  return (dispatch) => {
    dispatch(boardCopySuccessClearState());
  };
};

export const fetchAttachments = (projectID, accessToken) => (dispatch) => {
  return dispatch(fetchProjectAttachments(projectID, accessToken));
};

// Fetches a single project by a provided id
export const fetchProject = (id) => {
  return (dispatch, getState) => {
    const { entities = {} } = getState();
    const { projects = {} } = entities;
    return new Promise((resolve, reject) => {
      dispatch(projectFetchRequest(id));
      Projects.fetchByExternalID(id, (res) => {
        if (res.error) {
          return reject(dispatch(projectFetchFailure(id, res.error)));
        }
        const reducedProjects = _.reduce(projects, (obj, val, key) => {
          const newObj = obj;
          if (key === id) newObj[key] = res;
          return newObj;
        }, {});
        const newEntities = Object.assign(entities, {
          projects: reducedProjects
        });
        return resolve(dispatch(projectFetchSuccess({ entities: newEntities })));
      });
    });
  };
};

export const joinBoard = (projectID, ssoID, accessToken, externalID, projectInviteId) => {
  return dispatch => {
    return dispatch(createProjectAttachments(projectID, ssoID, accessToken, 'COLLABORATOR', projectInviteId))
      .then(() => {
        // quick hack re-fetch :|
        return dispatch(fetchProject(externalID));
      });
  };
};

export const loadProject = (id) => (dispatch) => {
  // Check for cached project and do not fetch if it exists.
  return dispatch(fetchProject(id));
};

export const batchUpdateAttachments = (accessToken, payload) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch(projectAttachmentsBatchUpdateRequest());

      return Projects.batchUpdate(accessToken, payload, (res) => {
        if (200 !== res.statusCode) {
          dispatch(projectAttachmentsBatchUpdateFailure(res.message));
          return reject(res.message);
        }

        const { entities } = getState();
        const { attachments } = entities;

        const attachmentIDs = payload.batch.map((attachment) => {
          if ('delete' === attachment.action) {
            return attachment._id;
          }

          return undefined;
        });

        const newAttachments = _.filter(attachments, (n) => {
          return -1 === attachmentIDs.indexOf(n._id);
        });

        const normalizedAttachments = { ...normalize(newAttachments, projectSchemas.ATTACHMENTS_ARRAY) };

        return resolve(dispatch(projectAttachmentsBatchUpdateSuccess(normalizedAttachments, res)));
      });
    });
  };
};

export const updateProject = (projectID, accessToken, payload) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(projectUpdateRequest(projectID));
      return Projects.updateById(projectID, accessToken, payload, (res) => {
        if (200 !== res.statusCode) {
          dispatch(projectUpdateFailure(projectID, res.message));
          return reject(res.message);
        }

        const response = { ...normalize(res.project, projectSchemas.PROJECT) };

        return resolve(dispatch(projectUpdateSuccess(response)));
      });
    });
  };
};

export const attachmentDetail = (listingID, updateObject) => {
  return (dispatch, getState) => {
    const { entities: { attachments: attachmentsByListing = {} } } = getState();
    const updatedAttachments = _.reduce(attachmentsByListing, (acc, val, key) => {
      if (key === listingID) {
        acc[key] = { ...val, ...updateObject };
      } else {
        acc[key] = val;
      }
      return acc;
    }, {});
    const normalizedAttachments = { ...normalize(updatedAttachments, projectSchemas.ATTACHMENTS_ARRAY) };
    dispatch(fetchAttachmentDetails(normalizedAttachments));
  };
};

export const deleteBoard = (boardID, accessToken, boardExternalID) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(boardDeleteRequest(boardID));
      return Projects.deleteBoard(boardID, accessToken, (res) => {
        if (200 !== res.statusCode) {
          dispatch(boardDeleteFailure(boardID, res.message));
          return reject(res.message);
        }
        const externalID = res.project.external_id || boardExternalID;
        return resolve(dispatch(boardDeleteSuccess(externalID)));
      });
    });
  };
};

// project board

function favoritedListingsFetchSuccsess (response) {
  return {
    type: types.FAVORITED_LISTINGS_FETCH_SUCCESS,
    response
  };
}

function favoritedListingsFetchRequest () {
  return {
    type: types.FAVORITED_LISTINGS_FETCH_REQUEST
  };
}

function favoritedListingsFetchFailure (error) {
  return {
    type: types.FAVORITED_LISTINGS_FETCH_FAILURE,
    error
  };
}

function projectBoardFetchSuccess (response) {
  return {
    type: types.PROJECT_BOARD_FETCH_SUCCESS,
    schema: projectSchemas.PROJECT_ARRAY,
    response
  };
}

function projectBoardFetchRequest () {
  return {
    type: types.PROJECT_BOARD_FETCH_REQUEST,
    request: true
  };
}

function projectBoardFetchFailure (id, error) {
  return {
    type: types.PROJECT_BOARD_FETCH_FAILURE,
    id,
    error
  };
}

function projectListingsFetch (projectID) {
  return {
    type: types.PROJECT_BOARD_LISTINGS_FETCH_REQUEST,
    projectID
  };
}

export function projectListingsFetchSuccess (response) {
  return {
    type: types.PROJECT_BOARD_LISTINGS_FETCH_SUCCESS,
    schema: projectSchemas.PROJECT,
    response
  };
}

function projectListingsFetchFailure (error) {
  return {
    type: types.PROJECT_BOARD_LISTINGS_FETCH_FAILURE,
    error
  };
}

export const fetchProjectDetails = (projectExternalID) => (dispatch) => {
  dispatch(projectFetchRequest(projectExternalID));
  Projects.fetchByExternalID(projectExternalID, (res) => {
    if (res.error) {
      return dispatch(projectFetchFailure(projectExternalID, res.error));
    }
    const response = { ...normalize(res, projectSchemas.PROJECT) };
    return dispatch(projectFetchSuccess(response));
  });
};


export const fetchProjectListings = (project) => (dispatch, getState) => {
  dispatch(projectListingsFetch(project._id));

  const fetchError = error => {
    return dispatch(projectListingsFetchFailure(error));
  };

  // #3 fix data to store
  const updateStore = function updateStore (dispatch, getState, projectSchemas, projectWithListings) {
    const { project, listings, attachments } = projectWithListings;
    const { entities } = getState();
    const originalProjects = _.cloneDeep(entities.projects);
    const updatedProjectInfoWithListings = { ...project, listings };
    const updatedProjectsMap = _.merge(originalProjects, { [updatedProjectInfoWithListings.external_id]: updatedProjectInfoWithListings });
    const listingsIndex = _.keyBy(listings, '_id');

    // Map attachments and add listing that belongs to it
    const addListingToAttachment = (listingsMap, attachments) => {
      return attachments.map(attachment => {
        return { ...attachment, listing: listingsMap[attachment.value] };
      });
    };

    const updatedAttachments = normalize(addListingToAttachment(listingsIndex, attachments), projectSchemas.ATTACHMENTS_ARRAY);
    dispatch(projectListingsFetchSuccess({ entities: _.merge(entities, { projects: updatedProjectsMap, attachments: updatedAttachments.entities.attachments, hasFetchedListings: true }) }));
  }.bind(this, dispatch, getState, projectSchemas);

  // #2 get listing bodies
  const getListingsByID = function getListingsByID (bound, projectInfo) {
    const { listingIDs } = projectInfo;

    if (!listingIDs.length) {
      return (updateStore(projectInfo));
    }

    return new Promise((resolveListings) => {
      bound.Listings.searchByIDs(listingIDs, function searchByIDsCB (projectInfo, res) {
        const listings = res.hits.hits;
        resolveListings(_.merge({}, projectInfo, { listings }));
      }.bind(this, projectInfo));
    })
      .then(updateStore)
      .catch(fetchError);
  }.bind(this, Listings);

  // #1 get listing IDs by project ID
  const fetchListingsByID = (project, accessToken) => {
    return new Promise((resolveID, rejectID) => {
      Projects.fetchListingsByProjectId(project._id, accessToken, (res) => {
        if (200 === res.statusCode) {
          const listingIDs = res.attachments.map(function listingValue (listing) { return listing.value; });
          resolveID({ project: project, listingIDs: listingIDs, attachments: res.attachments });
        } else {
          rejectID(res.error);
        }
      });
    })
      .then(getListingsByID)
      .catch(fetchError);
  };

  fetchListingsByID(project)
    .then(fetchListingsByID)
    .catch(fetchError);
};

const fetchAllBoards = (ssoid, accessToken) => {
  return dispatch => {
    dispatch(projectBoardFetchRequest());
    Projects.fetchUserProjectDetails(ssoid, accessToken, (res) => {
      if (res.error) {
        return dispatch(projectBoardFetchFailure(ssoid, res.error || res.errors));
      }
      const response = { ...normalize(res.projects, projectSchemas.PROJECT_ARRAY) };
      return dispatch(projectBoardFetchSuccess(response));
    });
  };
};

export const loadAllBoards = (ssoid, accessToken) => (dispatch) => {
  return dispatch(fetchAllBoards(ssoid, accessToken));
};

const fetchFavoritedListings = (ssoid, query, accessToken) => {
  return dispatch => {
    dispatch(favoritedListingsFetchRequest());
    Projects.fetchFavBoardByUser(ssoid, query, accessToken, (res) => {
      if (res.error) {
        return dispatch(favoritedListingsFetchFailure(ssoid, res.error || res.errors));
      }
      return dispatch(favoritedListingsFetchSuccsess(res));
    });
  };
};

export const loadAllFavoritedListings = (ssoid, query, accessToken) => (dispatch) => {
  return dispatch(fetchFavoritedListings(ssoid, query, accessToken));
};

// create project modal
function projectCreateSuccess (response) {
  return {
    type: types.PROJECT_BOARD_CREATE_SUCCESS,
    schema: projectSchemas.PROJECT,
    response
  };
}

function projectCreateRequest () {
  return {
    type: types.PROJECT_BOARD_CREATE_REQUEST
  };
}

function projectCreateFailure (error) {
  return {
    type: types.PROJECT_BOARD_CREATE_FAILURE,
    error
  };
}

const createProject = (accessToken, payload) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(projectCreateRequest());

      Projects.createProject(accessToken, payload, (res) => {
        if (200 !== res.statusCode) {
          dispatch(projectCreateFailure(res.message));
          return reject(res);
        }
        const response = { ...normalize(res.body.project, projectSchemas.PROJECT) };
        dispatch(projectCreateSuccess(response));
        return resolve(res);
      });
    });
  };
};

export const postProject = (accessToken, payload) => (dispatch, getState) => {
  return dispatch(createProject(accessToken, payload, getState));
};

// Resets the currently visible error message.
export const resetErrorMessage = () => (dispatch) => {
  return dispatch({
    type: types.RESET_ERROR_MESSAGE
  });
};
